export interface AppSessionData {
  sessionId: string;
  createdAt: number;
  lastExtendedAt: number;
}

let currentAppSession: AppSessionData | null = null;
const listeners = new Set<(appSession?: AppSessionData | null) => void>();

export function getAppSessionId(): string | null {
  return currentAppSession?.sessionId ?? null;
}

export function getAppSessionData(): AppSessionData | null {
  return currentAppSession;
}

export function setAppSessionId(
  id: string | null,
  createdAt?: number,
  lastExtendedAt?: number
): void {
  // Value to null indicates session end - clear session and notify listeners
  if (id === null) {
    if (currentAppSession !== null) {
      currentAppSession = null;
      listeners.forEach((listener) => listener(null));
    }
    return;
  }

  const now = Date.now();

  // If session ID is the same, don't update
  if (currentAppSession?.sessionId === id) {
    return;
  }

  // New session - use provided createdAt/lastExtendedAt or current time
  currentAppSession = {
    sessionId: id,
    createdAt: createdAt ?? now,
    lastExtendedAt: lastExtendedAt ?? now,
  };

  listeners.forEach((listener) => listener(currentAppSession));
}

export function updateAppSessionExtendTime(): void {
  if (currentAppSession) {
    currentAppSession.lastExtendedAt = Date.now();
    listeners.forEach((listener) => listener(currentAppSession));
  }
}

export function subscribe(
  listener: (appSession?: AppSessionData | null) => void
): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
